import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy WordPress path — permanently redirect to the real blog landing page.
// Exact-match only: dedicated /blog/* child redirect routes handle nested paths.
export const Route = createFileRoute("/blog")({
  beforeLoad: ({ location }) => {
    if (location.pathname.replace(/\/+$/, "") === "/blog") {
      throw redirect({ href: "/hair-loss-blog/", statusCode: 301 });
    }
  },
});
